import React, { createContext, useContext } from 'react';

interface FocusedExecutionContextValue {
  isInFocusedExecution: boolean;
}

const FocusedExecutionContext = createContext<FocusedExecutionContextValue>({
  isInFocusedExecution: false,
});

const FocusedExecutionProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <FocusedExecutionContext.Provider value={{ isInFocusedExecution: true }}>
      {children}
    </FocusedExecutionContext.Provider>
  );
};

export const useIsInFocusedExecution = (): boolean => {
  return useContext(FocusedExecutionContext).isInFocusedExecution;
};
